import {
  ADD_PRODUCT_SUBMIT,
  CLEAR_CURRENT_SUBMIT,
  CLEAR_FILTER_SUBMIT,
  DELETE_PRODUCT_SUBMIT,
  EDIT_PRODUCT_SUBMIT,
  FILTER_PRODUCTS_SUBMIT,
  GET_PRODUCTS_SUBMIT,
  SET_CURRENT_SUBMIT,
  SET_UPDATE_SUBMIT,
  UPDATE_PRODUCT_SUBMIT,
  LOAD_IMAGES_SUBMIT,
  SET_RESETTING_SUBMIT,
  SUBMIT_PRODUCTS_SUBMIT,
} from 'context/types'

import { oatVarietyOptions as brownRiceVarietyOptions } from 'views/WholeGrains/BrownRice/constants'
import {
  oatVarietyOptions as oatsOatmealVarietyOptions,
  oatTypeOptions as oatsOatmealTypeOptions,
} from 'views/WholeGrains/OatsOatmeal/constants'
import { textureOptions as peanutButterTextureOptions } from 'views/Legumes/PeanutButter/constants'
import {
  fruitTypeOptions as frozenFruitTypeOptions,
  vegTypeOptions as frozenVegTypeOptions,
  packageTypeOptions as frozenPackageTypeOptions,
} from 'views/FruitsAndVegs/FrozenVegsFruits/constants'
import {
  fruitTypeOptions as cannedFruitTypeOptions,
  vegTypeOptions as cannedVegTypeOptions,
  fruitContainerTypeOptions as cannedFruitContainerTypeOptions,
  vegContainerTypeOptions as cannedVegContainerTypeOptions,
} from 'views/FruitsAndVegs/CannedVegsFruits/constants'
import {
  driedFruitsTypeOptions,
  packageTypeOptions as driedFruitsPackageTypeOptions,
} from 'views/FruitsAndVegs/DriedFruits/constants'

export default (state, action) => {
  let targetProduct
  switch (action.type) {
    case GET_PRODUCTS_SUBMIT:
      return {
        ...state,
        products: action.payload,
        filtered: null,
      }
    case DELETE_PRODUCT_SUBMIT:
      return {
        ...state,
        products: state.products.filter(
          product => product.UPC !== action.payload
        ),
      }
    case FILTER_PRODUCTS_SUBMIT:
      // console.log('action.payload.validCategories: ' + JSON.stringify(action.payload))
      console.log(state.products)
      return {
        ...state,
        filtered: state.products.filter(product => {
          const matchesProductType = action.payload.validProductTypes
            ? action.payload.validProductTypes.includes(
                `${product.fkCategory}/${product.fkSubCategory}`
              )
            : action.payload.validCategories.includes(product.fkCategory) &&
              action.payload.validSubCategories.includes(product.fkSubCategory)
          return matchesProductType && product.fkApprovalStatus === 0
        }),
      }
    /* if (
        ['02', '03', '06', '16', '19', '52'].includes(action.payload.category)
      ) {
        return {
          ...state,
          filtered: state.products.filter(
            product =>
              product.fkCategory === action.payload.category &&
              product.fkSubCategory === action.payload.subCategory &&
              product.fkApprovalStatus === 0
          ),
        }
      } else {
        return {
          ...state,
          filtered: state.products.filter(
            product =>
              product.fkCategory === action.payload.category &&
              product.fkApprovalStatus === 0
          ),
        }
      } */
    case CLEAR_FILTER_SUBMIT:
      return {
        ...state,
        filtered: null,
      }
    case SET_CURRENT_SUBMIT:
      return {
        ...state,
        current: action.payload,
      }
    case CLEAR_CURRENT_SUBMIT:
      return {
        ...state,
        current: null,
        updating: false,
      }
    case ADD_PRODUCT_SUBMIT:
      return {
        ...state,
        products: [action.payload, ...state.products],
        current: null,
        updating: false,
        resetting: true,
      }
    case EDIT_PRODUCT_SUBMIT:
      targetProduct =
        typeof action.payload === 'string'
          ? state.products.find(({ UPC }) => UPC === action.payload)
          : action.payload
      targetProduct = { ...targetProduct, oldUPC: targetProduct.UPC }
      console.log('targetProduct is: ' + JSON.stringify(targetProduct))
      switch (targetProduct.fkCategory) {
        case '06':
          if (
            !peanutButterTextureOptions.some(e => {
              return (
                JSON.stringify({
                  value: targetProduct.PBTexture,
                  label: targetProduct.PBTexture,
                }) === JSON.stringify(e)
              )
            })
          ) {
            targetProduct.otherTexture = targetProduct.PBTexture
            targetProduct.PBTexture = 'Other'
          }
          break
        case '16':
          switch (targetProduct.fkSubCategory) {
            case '003':
              if (
                !brownRiceVarietyOptions.some(e => {
                  return (
                    JSON.stringify({
                      value: targetProduct.OatVariety,
                      label: targetProduct.OatVariety,
                    }) === JSON.stringify(e)
                  )
                })
              ) {
                targetProduct.otherType = targetProduct.OatVariety
                targetProduct.OatVariety = 'Other'
              }
              break
            case '005':
              if (
                !oatsOatmealTypeOptions.some(e => {
                  return (
                    JSON.stringify({
                      value: targetProduct.OatType,
                      label: targetProduct.OatType,
                    }) === JSON.stringify(e)
                  )
                })
              ) {
                targetProduct.otherType = targetProduct.OatType
                targetProduct.OatType = 'Other'
              }
              if (
                !oatsOatmealVarietyOptions.some(e => {
                  return (
                    JSON.stringify({
                      value: targetProduct.OatVariety,
                      label: targetProduct.OatVariety,
                    }) === JSON.stringify(e)
                  )
                })
              ) {
                targetProduct.otherVariety = targetProduct.OatVariety
                targetProduct.OatVariety = 'Other'
              }
              break
            default:
              break
          }
          break
        case '19':
          switch (targetProduct.fkSubCategory) {
            case '001FF':
            case '001FV':
              if (
                !frozenPackageTypeOptions.some(e => {
                  return (
                    JSON.stringify({
                      value: targetProduct.PackageType,
                      label: targetProduct.PackageType,
                    }) === JSON.stringify(e)
                  )
                })
              ) {
                targetProduct.otherPackageType = targetProduct.PackageType
                targetProduct.PackageType = 'Other'
              }
              if (targetProduct.FrozenProductType === 'Fruit') {
                if (
                  !frozenFruitTypeOptions.some(e => {
                    return (
                      JSON.stringify({
                        value: targetProduct.ItemType,
                        label: targetProduct.ItemType,
                      }) === JSON.stringify(e)
                    )
                  })
                ) {
                  targetProduct.otherType = targetProduct.ItemType
                  targetProduct.ItemType = 'Other'
                }
              } else {
                if (
                  !frozenVegTypeOptions.some(e => {
                    return (
                      JSON.stringify({
                        value: targetProduct.ItemType,
                        label: targetProduct.ItemType,
                      }) === JSON.stringify(e)
                    )
                  })
                ) {
                  targetProduct.otherType = targetProduct.ItemType
                  targetProduct.ItemType = 'Other'
                }
              }
              break
            case '001CF':
            case '001CV':
              if (
                !cannedFruitTypeOptions.some(e => {
                  return (
                    JSON.stringify({
                      value: targetProduct.ItemType,
                      label: targetProduct.ItemType,
                    }) === JSON.stringify(e)
                  )
                }) &&
                !cannedVegTypeOptions.some(e => {
                  return (
                    JSON.stringify({
                      value: targetProduct.ItemType,
                      label: targetProduct.ItemType,
                    }) === JSON.stringify(e)
                  )
                })
              ) {
                targetProduct.otherType = targetProduct.ItemType
                targetProduct.ItemType = 'Other'
              }
              if (
                !cannedFruitContainerTypeOptions.some(e => {
                  return (
                    JSON.stringify({
                      value: targetProduct.ContainerType,
                      label: targetProduct.ContainerType,
                    }) === JSON.stringify(e)
                  )
                }) &&
                !cannedVegContainerTypeOptions.some(e => {
                  return (
                    JSON.stringify({
                      value: targetProduct.ContainerType,
                      label: targetProduct.ContainerType,
                    }) === JSON.stringify(e)
                  )
                })
              ) {
                targetProduct.otherContainerType = targetProduct.ContainerType
                targetProduct.ContainerType = 'Other'
              }
              break
            case '004':
              if (
                !driedFruitsTypeOptions.some(e => {
                  return (
                    JSON.stringify({
                      value: targetProduct.DFType,
                      label: targetProduct.DFType,
                    }) === JSON.stringify(e)
                  )
                })
              ) {
                targetProduct.otherType = targetProduct.DFType
                targetProduct.DFType = 'Other'
              }
              if (
                !driedFruitsPackageTypeOptions.some(e => {
                  return (
                    JSON.stringify({
                      value: targetProduct.DFPackageType,
                      label: targetProduct.DFPackageType,
                    }) === JSON.stringify(e)
                  )
                })
              ) {
                targetProduct.otherPackageType = targetProduct.DFPackageType
                targetProduct.DFPackageType = 'Other'
              }
              console.log(
                'targetProduct after all changes in submitReducer: ' +
                  JSON.stringify(targetProduct)
              )
              break
            default:
              break
          }
          break
        default:
          break
      }
      return {
        ...state,
        current: targetProduct,
        updating: true,
      }
    case UPDATE_PRODUCT_SUBMIT:
      targetProduct = action.payload.product || action.payload
      return {
        ...state,
        products: state.products.map(product =>
          product.UPC === (action.payload.originalUPC || targetProduct.UPC)
            ? targetProduct
            : product
        ),
        current: null,
        updating: false,
        resetting: true,
      }
    case SUBMIT_PRODUCTS_SUBMIT:
      return {
        ...state,
        products: state.products.map(product =>
          action.payload.includes(product.pkProduct)
            ? { ...product, fkApprovalStatus: 1 }
            : product
        ),
        current: null,
        updating: false,
        resetting: true,
      }
    case SET_UPDATE_SUBMIT:
      return {
        ...state,
        updating: action.payload,
      }
    case SET_RESETTING_SUBMIT:
      return {
        ...state,
        resetting: action.payload,
      }
    case LOAD_IMAGES_SUBMIT:
      if (state.current?.pkProduct !== action.payload.pkProduct) {
        return state
      }
      return {
        ...state,
        current: {
          ...state.current,
          images: action.payload.images,
        },
      }
    default:
      return state
  }
}
